import { CallAPIAction, Status } from 'api/types'
import { OnlinePaymentVisaFailResponse, OnlinePaymentVisaResponse } from 'api/evisaAPI/visas'
import { PayfortBill } from 'common/types/transformedRespTypes'
import Actions from 'redux/actions'

type State = {
  status?: boolean
  bill?: PayfortBill
  errorMessage?: string
} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.ONLINE_PAYMENT_VISA_ASYNC,
    Actions.ONLINE_PAYMENT_VISA_SUCCESS,
    Actions.ONLINE_PAYMENT_VISA_FAIL,
    OnlinePaymentVisaResponse,
    OnlinePaymentVisaFailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.ONLINE_PAYMENT_VISA_SUCCESS: {
      const { payload } = action
      return {
        ...state,
        ...action.status,
        status: payload.status,
        bill: {
          params: payload.bill.params,
          url: payload.bill.url,
        },
      }
    }
    case Actions.ONLINE_PAYMENT_VISA_ASYNC: {
      return {
        ...state,
        ...action.status,
      }
    }
    case Actions.ONLINE_PAYMENT_VISA_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error?.message || '',
      }
    }
    default:
      return state
  }
}
